import { useEffect, useState, useContext } from "react";
import Drawer from "../../components/drawer/Drawer";
import AddressItem from "../../components/kits/addressListItem/AddressItem";
import CustomButton from "../../components/kits/custom-button/CustomButton";
import useAxios from "../../services/useAxios";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import "./address.scss";
import Add from "./Add";
import "./address.scss";
import CartItemBtn from "../../components/cartitem/CartitemBtn";

import { ShoppingCartIcon } from "../../components/kits/Icons/Icons";

import CartItem from "../../components/cartitem/CartItem";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  AddIcon,
} from "../../components/kits/Icons/Icons";
import { NavLink } from "react-router-dom";
import colorSchema from "../../assets/kits/colors/colors.module.scss";
import useWindowSize from "../../hooks/useWindowSize";

export default function Address() {
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(617);
  const [component, setComponent] = useState(<></>);
  const [allAddress, setAllAddress] = useState([]);
  const auth = useContext(AuthenticationContext);
  const [selectedId, setSelectedId] = useState("");
  const [updaterAddress, setUpdaterAddress] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const windowSize = useWindowSize();
  const {
    loading,
    execute: AddressList,
    cancel,
  } = useAxios("api/Find_UsersAddress", {
    conditions: `user_id/=/${auth.userInfo.id}@@status/=/0`,
  });

  const updateAddress = () => {
    setUpdaterAddress((prev) => !prev);
  };

  useEffect(() => {
    console.log(auth, "auth");
    async function loadPage() {
      AddressList().then((res) => {
        setAllAddress(res);
      });
    }
    loadPage();
  }, [updaterAddress]);
  useEffect(() => {
    windowSize.height > 670 ? setHeight(617) : setHeight("85%");
  }, [windowSize]);
  return (
    <div className="pt-t-10 address-page d-flex flex-column h-100">
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ height: 48 }}
      >
        <div className="mr-r-20 d-flex align-items-center">
          <NavLink to="/user-profile">
            <ArrowRightIcon />
          </NavLink>

          <span className="mr-r-8 title-h3-b">مدیریت آدرس ها </span>
        </div>
        <div>
          <button
            onClick={() => {
              setIsOpen2(true);
              setComponent(
                <Add
                  setHeight={setHeight}
                  setIsOpen2={setIsOpen2}
                  setUpdaterAddress={setUpdaterAddress}
                />
              );
            }}
            className="btn title-h5-m d-flex mr-l-8 border-0"
          >
            <AddIcon width="20px" height="20px" />
            <span className="mr-r-4">افزودن</span>
          </button>
        </div>
      </div>
      {auth.userInfo.addresses.length != 0 ? (
        <div className="pd-x-20 mr-t-16">
          {auth.userInfo.addresses.map((item, index) => (
            <>
              <AddressItem
                id={item.id}
                title={item.title}
                address={item.address}
                selected={item.id == selectedId ? true : false}
                RadioBtnFunc={(id) => setSelectedId(id)}
                hasRadioBtn={false}
                item={item}
                updateAddress={updateAddress}
              />
              {index != auth.userInfo.addresses.length - 1 && (
                <div className="mr-y-16 separator-line" />
              )}
            </>
          ))}
        </div>
      ) : (
        <div className="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1">
          <div className="square" />
          <p className="desc-c-l mr-y-12" style={{ color: "#111827" }}>
            هنوز آدرسی ثبت نشده است.
          </p>
          <CustomButton
            className=""
            buttonStyle="secondary"
            state="default"
            size="medium"
            onClick={() => {
              setIsOpen2(true);
              setComponent(
                <Add
                  setHeight={setHeight}
                  setIsOpen2={setIsOpen2}
                  setUpdaterAddress={setUpdaterAddress}
                />
              );
            }}
          >
            <span className=" title-h4-m"> افزودن آدرس</span>

            <ArrowLeftIcon color={`${colorSchema.schema_primary_main}`} />
          </CustomButton>
        </div>
      )}
      <Drawer
        isOpen={isOpen2}
        onClose={() => setIsOpen2(false)}
        height={height}
      >
        <div className="demo-content pd-x-16">{component}</div>
      </Drawer>
    </div>
  );
}
